import {createStore, applyMiddleware, combineReducers} from 'redux';
import thunkMiddleware from 'redux-thunk';

import auth from './02-reducers/auth';
import adminCategories from './02-reducers/adminCategories';
import adminProducts from './02-reducers/adminProducts';
import adminImages from './02-reducers/adminImages';
import system from './02-reducers/system';

const initialState = {};

export default () => {
	return createStore(
		combineReducers({
			auth,
			adminCategories,
			adminProducts,
			adminImages,
			system,
		}),
		initialState,
		applyMiddleware(thunkMiddleware)
	);
}


// WEBPACK FOOTER //
// ./src/store.js